import { css } from 'styled-components';
import {
  CtaWrapper,
  Heading,
  ImageWrapper,
  StyledPrimaryCta,
  StyledSecondaryCta,
  StyledText,
  TextWrapper,
  ThreeCardVariantPrimaryCta,
  ThreeCardVariantText,
} from '../../../../../components/ImageAndCtaCards/ImageAndCtaCard/styles';
import mediaQuery from '../../../../../helpers/mediaQuery';
import spacing from '../../../../../helpers/spacing';

export default css`
  ${Heading} {
    margin-bottom: ${spacing(1)};
  }

  ${StyledText} {
    margin-bottom: ${spacing(4)};
  }

  ${ThreeCardVariantText} {
    margin-bottom: ${spacing(4)};
  }

  ${TextWrapper} {
    margin: ${spacing(3)};
    margin-bottom: 0;
  }

  ${CtaWrapper} {
    margin: 0 ${spacing(3)};
  }

  ${StyledPrimaryCta} {
    ${mediaQuery.tabletLandscape`
      margin-bottom: ${spacing(3)};
      margin-right: ${spacing(2)};
    `}
  }

  ${StyledSecondaryCta} {
    ${mediaQuery.tabletLandscape`
      margin-bottom: ${spacing(3)};
      margin-right: ${spacing(2)};
    `}
  }

  ${ThreeCardVariantPrimaryCta} {
    ${mediaQuery.tabletLandscape`
      margin-right: ${spacing(2)};
  `}
  }

  ${ImageWrapper} {
    border-radius: 0;
  }
`;
